import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { candidate } from '../../data/site';
const highlights = [{
  label: 'Public service',
  value: 'Two terms as Governor of Osun State, 2015 — 2023'
}, {
  label: 'Enterprise',
  value: 'Built an agro-processing business employing 22,000 out-growers'
}, {
  label: 'Development finance',
  value: 'Turned around a national industrial bank and published its books'
}];
export function MeetCandidate() {
  const navigate = useNavigate();
  return <section aria-labelledby="meet-heading" className="bg-sand-50 py-16 sm:py-20 lg:py-28" data-id="element-244" data-mp="pin7y30oy5w">
      <div className="mx-auto grid max-w-content items-center gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-245" data-mp="3rw1ux4dk47zz">
        <Reveal className="lg:col-span-5" data-id="element-246" data-mp="2getromencxxe">
          <div className="relative" data-id="element-247" data-mp="2gdqyg7tuqjeb">
            <div className="overflow-hidden rounded-media" data-id="element-248" data-mp="2ggwq9utv7zdq">
              <img src={candidate.portraitSigning} alt={`${candidate.name} signing a memorandum of understanding`} className="h-full w-full object-cover" loading="lazy" width={1084} height={1447} data-id="element-249" data-mp="lc9blb0kzkb0" />
            </div>
            <span aria-hidden className="absolute -bottom-4 -right-4 hidden h-24 w-24 rounded-br-media border-b-4 border-r-4 border-gold-500 lg:block" data-id="element-250" data-mp="hbh34jzj9jfs" />
          </div>
        </Reveal>

        <Reveal delay={0.06} className="lg:col-span-7" data-id="element-251" data-mp="3ppfz3lmi94ta">
          <p className="flex items-center gap-2.5 text-[13px] font-semibold text-green-700" data-id="element-252" data-mp="3pqr05dokfygp">
            <span aria-hidden className="h-px w-6 bg-current opacity-60" data-id="element-253" data-mp="3traxoid1x43d" />
            Meet {candidate.shortName}
          </p>
          <h2 id="meet-heading" className="mt-3 max-w-[18ch] font-display text-[30px] leading-[1.1] tracking-[-0.02em] text-ink sm:text-[38px] lg:text-[44px]" data-id="element-254" data-mp="3ftcn7o1uprt5">
            Leadership built on service, enterprise and evidence.
          </h2>
          <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-255" data-mp="1lhl7ijou48k3">
            Adebayo Sanni Bello grew up in Ilesa, trained as an engineer in Zaria, and spent the
            first half of his career building factories in places most investors avoided. He
            entered public service in 2015 with a state that owed eleven months of salaries and
            left it paying on the 25th of every month. He is running because he believes Nigeria’s
            problem is not ambition — it is delivery.
          </p>

          <dl className="mt-8 grid gap-5 sm:grid-cols-3" data-id="element-256" data-mp="1v8xzdbamuyq4">
            {highlights.map(item => <div key={item.label} className="border-t border-sand-300 pt-4" data-id="element-257" data-mp="osm0t93wfeu0">
                <dt className="text-[12px] font-bold uppercase tracking-[0.12em] text-green-700" data-id="element-258" data-mp="oqj11xcy27c3">
                  {item.label}
                </dt>
                <dd className="mt-2 text-[14px] leading-relaxed text-slate-600" data-id="element-259" data-mp="9qx2sf59ttoy">{item.value}</dd>
              </div>)}
          </dl>

          <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-260" data-mp="emufmbhbshwz">
            <Button size="lg" onClick={() => navigate('/candidate')} data-id="element-261" data-mp="jn9w3bwwm5j6">
              Discover the Journey
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-262" data-mp="ogbazjx4252r" />
            </Button>
            <Button variant="tertiary" onClick={() => navigate('/track-record')} data-id="element-263" data-mp="sfk88yrd0l32">
              View full biography
              <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-264" data-mp="xdlqjhgyogdh" />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>;
}